import '@/plugins/vue-composition-api.js'
import '@/styles/styles.scss'
import Zendesk from '@dansmaculotte/vue-zendesk'
import VJsf from '@koumoul/vjsf'
import '@koumoul/vjsf/dist/main.css'
import { createPinia, PiniaVuePlugin } from 'pinia'
import Vue from 'vue'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import VueTour from 'vue-tour'
import VueGtm from '@gtm-support/vue2-gtm'
import App from './App.vue'
import './assets/tailwind.css'
import axios from './plugins/axios.js'
import vuetify from './plugins/vuetify.js'
import router from './router/index.js'
import store from './store/index.js'
import * as Sentry from '@sentry/vue'
import { BrowserTracing, Integrations } from '@sentry/tracing'

require('vue-tour/dist/vue-tour.css')

const debug = process.env.NODE_ENV === 'development'

Vue.use(VueTour)

Vue.use(PiniaVuePlugin)
Vue.use(VueTelInputVuetify, {
    vuetify,
})

const pinia = createPinia()
Vue.use(axios)
Vue.component('VJsf', VJsf)
Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'development') {
    Vue.use(VueGtm, {
        id: 'GTM-N2F27N6', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
        queryParams: {
        // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
        // gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
        // gtm_preview: 'env-4',
        // gtm_cookies_win: 'x',
        },
        defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
        compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
        nonce: '2726c7f26c', // Will add `nonce` to the script tag
        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: false, // Whether or not display console logs debugs (optional)
        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
        trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
    })
    Sentry.init({
        Vue,
        dsn: 'https://2001f2f585bc4f8aaac94ff63a7889ee@o422586.ingest.sentry.io/6713813',
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ['localhost', '*.phox.app', /^\//],
            }),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        release: process.env.VUE_APP_VERSION,
    })
}

// Sentry.init({
//     Vue,
//     dsn: 'https://2001f2f585bc4f8aaac94ff63a7889ee@o422586.ingest.sentry.io/6713813',
//     integrations: [
//         new BrowserTracing({
//             routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//             tracingOrigins: ['localhost', '*.phox.app', /^\//],
//         }),
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//     release: process.env.VUE_APP_VERSION,
//     logErrors: true
// })

Vue.use(Zendesk, {
    key: 'ead6c341-7c18-4a84-b096-6cbf7c2beb5c',
    disabled: false,
    hideOnLoad: false,
    settings: {
        webWidget: {
            position: { horizontal: 'right', vertical: 'bottom' },
            offset: { horizontal: '50px', vertical: '50px' },
            zIndex: 999999,
            color: {
                theme: '#0071b2',
            },
        },
    },
})

new Vue({
    router,
    store,
    vuetify,
    pinia,
    render: h => h(App),
}).$mount('#app')
